export default __webpack_public_path__ + "static/media/place-8.83f3d39d.jpg";